import React from 'react';

import _memoize from 'lodash.memoize';
import cx from 'classnames';
import CardOverlay from '../CardOverlay/CardOverlayContainer';
import { Image } from '../../../../../Image';
import './_card-item.scss';



















class CardItem extends React.Component {


  handleMouseMovement = _memoize(
    ({ isHovered, delay }) => (e) => {
      const { isHovered: isHoveredState } = this.state;
      if (this._card && e.relatedTarget && !isHovered &&
      e.target && e.relatedTarget.nodeType && this._card.contains(e.relatedTarget)) {
        return;
      }

      if (isHoveredState === isHovered) {return;}

      if (!delay) {
        this.setState({ isHovered });
      } else {
        setTimeout(() => this.setState({ isHovered }), 300);
      }
    }
  );

  static displayName = 'CardItem';

  constructor(props) {
    super(props);
    this.state = {
      isHovered: false
    };
  }

  getOverlayProps = () => {
    const { overlayProps } = this.props;

    if (!overlayProps || !overlayProps.more || !overlayProps.more.options) {
      return overlayProps;
    }

    const newOptions = overlayProps.more.options.map((option) => (
    { ...option, action: () => this.actionWrapper(option.action) }));

    return {
      ...overlayProps,
      more: { ...overlayProps.more, options: newOptions }
    };
  };

  actionWrapper = (action) => {
    action();
    this.setState({ isHovered: false });
  };

  setCardRef = (ref) => {
    this._card = ref;
  };

  isNativeInteractive = (el) =>
  ['INPUT', 'TEXTAREA', 'SELECT', 'BUTTON'].includes(el.tagName) || el.isContentEditable;

  cardItemClick = (event) => {
    const target = event.target;

    if (!this.isNativeInteractive(target)) {
      event.stopPropagation(); // Stop only non-interactive clicks
    }

    const { onClick } = this.props;
    if (!onClick) {
      return;
    }

    onClick(event);
  };

  cardItemKeyDown = (event) => {
    const target = event.target;

    if (this.isNativeInteractive(target)) {
      return;
    }

    const { onClick } = this.props;

    if ((event.key === 'Enter' || event.key === ' ') && onClick) {
      if (event.key === ' ') event.preventDefault();
      onClick(event);
    }
  };

  render() {
    const { isHovered } = this.state;
    const {
      children,
      coverImageProps,
      customCoverImage,
      onClick,
      smallCoverImage,
      className,
      forceInteractive = false,
      selected,
      smallestCoverImage
    } = this.props;
    const overlayProps = this.getOverlayProps();
    const interactive = forceInteractive || Boolean(onClick && !overlayProps);

    return (
      /* eslint-disable jsx-a11y/no-noninteractive-tabindex */
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      <div
        className={cx(
          'card-item',
          {
            'card-item--interactive': interactive,
            'card-item--hovered': isHovered && interactive,
            'card-item--selected': selected
          },
          className
        )}
        onMouseOver={this.handleMouseMovement({ isHovered: true })}
        onFocus={this.handleMouseMovement({ isHovered: true })}
        onMouseLeave={this.handleMouseMovement({ isHovered: false })}
        onBlur={this.handleMouseMovement({ isHovered: false, delay: true })}
        onClick={interactive ? this.cardItemClick : undefined}
        onKeyDown={interactive ? this.cardItemKeyDown : undefined}
        role="button"
        aria-label="Card Item"
        tabIndex={onClick || overlayProps ? 0 : void 0}
        ref={this.setCardRef}>

        {
        (coverImageProps || customCoverImage) &&
        <div
          className={cx(
            'card-item__cover-image',
            { 'card-item__cover-image--small': smallCoverImage },
            { 'card-item__cover-image--smallest': smallestCoverImage }
          )}>

              {customCoverImage || <Image backgroundSize="cover" {...coverImageProps} />}
            </div>}


        <div className="card-item__content">{children}</div>
        {isHovered && overlayProps &&
        <CardOverlay {...overlayProps} />}

      </div>);

  }
}

export default CardItem;